import { Modal } from '@mantine/core';
import './styles.scss';

interface ModalProps {
  opened: boolean;
  onClose: () => void;
  message: string;
  backgroundColor: string;
  textColor: string;
}

const CustomModal = ({ opened, onClose, message, backgroundColor, textColor }: ModalProps) => {
  return (
    <Modal
      className="custom-modal"
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      closeOnClickOutside
      zIndex={60000}
      styles={{
        body: {
          backgroundColor: backgroundColor,
          color: textColor
        }
      }}
    >
      {message}
    </Modal>
  );
};

export default CustomModal;
